<div
  [ngClass]="{
    'p-0':
      contentFooter &&
      ((!contentFooter.social && !contentFooter.feedback) ||
        (contentFooter.social && !contentFooter.feedback) ||
        (contentFooter.feedback && !contentFooter.social))
  }"
  class="language-selector-container text-center text-md-left"
>
  <a
    #triggerElement
    (click)="open(); setTrackingObject($event)"
    aria-haspopup="true"
    class="lang-select-link language-firstitem icon-Language-selector"
    href="javascript:void(0);"
    id="footer-language-selector"
  >
    <span class="lang-selection">
      {{ prefLanguage?.countryName }} - {{ prefLanguage?.languageName }}
    </span>
    <span class="sr-only">Link to change the language</span>
  </a>
  <!-- <span *ngIf="secondaryPrefLanguage" class="language-divider" aria-hidden="true"></span> -->
  <div
    *ngIf="secondaryPrefLanguage"
    class="secondary-lang-container language-second-item"
  >
    <a
      (click)="changeLanguage()"
      aria-haspopup="true"
      class="lang-select-link"
      href="javascript:void(0);"
    >
      <span class="lang-selection">
        {{ secondaryPrefLanguage?.languageName }}
      </span>
      <span class="sr-only">Link to change the language</span>
    </a>
  </div>
</div>
<!-- Blow  block to display langauge in Hamberger -->
